import { Box, Grid, Typography } from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { useEffect } from 'react';
import { ReservationUrls } from '@/features/reservation/constants/urls';

const RELOAD_INTERVAL = 2000;

export function AfterRegisterPage(props: any) {
  const redirectOrReload = () => {
    // クエリパラメータにredirectUrlが設定されている場合はリダイレクト
    const searchParams = new URLSearchParams(window.location.search);
    const redirectUrl = searchParams.get('redirectUrl');
    if (redirectUrl) return (window.location.href = redirectUrl);

    if (window.location.pathname === '/transferSignUp') {
      window.location.href = ReservationUrls.Top;
      return;
    }

    // (LINEからではない)通常のログイン
    return window.location.reload();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      redirectOrReload();
    }, RELOAD_INTERVAL);

    return () => clearTimeout(timer);
  }, []);
  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={0} md={3} sm={2} />
          <Grid item xs={12} md={6} sm={8}>
            <Grid container direction={'column'} spacing={2}>
              <Grid item xs={12} mt={8} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <CheckCircle sx={{ color: '#3582BC', fontSize: 200 }} />
              </Grid>
              <Grid item xs={12} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <Typography mb={2} pt={2} fontSize={'16px'} className="font-bold">
                  登録が完了しました
                </Typography>
                <Typography mb={2} fontSize={'14px'}>
                  こちらのページは自動的に切り替わります
                  <br />
                  自動的に切り替わらない場合は
                  <br />
                  <span
                    onClick={() => redirectOrReload()}
                    style={{ cursor: 'pointer', color: '#3582BC', textDecoration: 'underline' }}
                  >
                    こちら
                  </span>
                  クリックしてください
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
